import axios from "axios";
import bcrypt from 'bcryptjs';

export default function Handler() {
    const host = `${process.env.REACT_APP_HOST}:${process.env.REACT_APP_PORT}`;
    // const host = "http://localhost:3000";
    const ourKey = process.env.REACT_APP_OUR_KEY;
    const oneSignalKey = process.env.REACT_APP_ONESIGNAL;
    const oneSignalAppID = process.env.REACT_APP_ONESIGNAL_APP_ID;

    const _checkPassword = (password, hash) => {
        return bcrypt.compareSync(password, hash);
    }

    const login = async (email, password) => {
        if (!email || !password) {
            throw new Error("Inserire i campi mancanti")
        }
        try {
            let loginUrl = host + '/apiPortale/rest/login';
            let body = {
                "email": process.env.REACT_APP_SERVICE_USER,
                "password": process.env.REACT_APP_SERVICE_PASS,
            }
            await axios.post(loginUrl, body, {
                headers: {
                    apiKey: ourKey
                }
            });
            let clinicaUrl = host + `/apiPortale/employees`;
            let clinicaRes = await axios.post(clinicaUrl, { email: email }, {
                headers: {
                    apiKey: ourKey
                }
            });
            if (!clinicaRes.data || clinicaRes.data.length === 0 || !clinicaRes.data.employees | clinicaRes.data.employees.length === 0) {
                throw new Error("Utente non trovato");
            }
            var bCheckPassword = _checkPassword(password, clinicaRes.data.employees[0].passwd);
            if (bCheckPassword)
                return (clinicaRes.data.employees[0]);
            else
                throw new Error("Password errata");
        } catch (error) {
            throw new Error(error.message);
        }
    }

    const getClientById = async (idClient) => {
        let url = host + `/apiPortale/clientById`;
        try {
            let res = await axios.post(url, { idClient: idClient }, {
                headers: {
                    apiKey: ourKey
                }
            });
            return res.data.customer
        } catch (error) {
            console.log(error);
        }
    }

    const getClientBySearch = async (numConto, microchip) => {
        var result = { client: null, pet: null };
        if (microchip !== "") {
            let url = host + `/apiPortale/microchip`;
            try {
                let res = await axios.post(url, { microchip: microchip }, {
                    headers: {
                        apiKey: ourKey
                    }
                });
                console.log(res);
                if (res.data.length === 0)
                    return result;
                let pet = res.data.pets[0];
                // let client = pet.associations.customer[0];
                let clientId = pet.id_customer;
                let client = await getClientById(clientId);
                result = { client: client, pet: pet };
                return result;
            } catch (error) {
                console.log(error);
                return result;
            }
        }
        else {
            let client = await getClientById(numConto);
            result = { client: client, pet: null };
            return result;
        }
    }

    const getPetById = async (idPet) => {
        let url = host + `/apiPortale/petById`;
        try {
            let res = await axios.post(url, { idPet: idPet }, {
                headers: {
                    apiKey: ourKey
                }
            });
            return res.data.pet
        } catch (error) {
            console.log(error);
        }
    }

    const getPetsOfCustomer = async (id) => {
        let url = host + `/apiPortale/petsOfCustomer`;
        try {
            let res = await axios.post(url, { id: id }, {
                headers: {
                    apiKey: ourKey
                }
            });
            return res.data.pets
        } catch (error) {
            console.log(error);
        }
    }

    const getPacchetti = async (id) => {
        let url = host + `/apiPortale/pacchetti`;
        try {
            let res = await axios.post(url, { id: id }, {
                headers: {
                    apiKey: ourKey
                }
            });
            return res.data.products[0]
        } catch (error) {
            console.log(error);
        }
    }

    const genera = async (pacchetto, body) => {
        let url = host + `/apiPortale/${pacchetto ? "registraPacchetto" : "generaMovimentazione"}`;
        try {
            let res = await axios.post(url, body, {
                headers: {
                    apiKey: ourKey
                }
            });
            return res.data.body.apiKey
        } catch (error) {
            console.log(error);
        }
    }

    const getStato = async (pacchetto, body) => {
        let url = host + `/apiPortale/getStato${pacchetto ? "Pacchetto" : "Movimentazione"}`;
        try {
            let res = await axios.post(url, body, {
                headers: {
                    apiKey: ourKey
                }
            });
            return res.data
        } catch (error) {
            console.log(error)
            return {
                stato: "Errore",
                statusCode: error?.response?.status
            }
        }
    }

    const sendNotifications = async ({ id, client, pet = null, importo, idClinica, nomeClinica, idProdotto = null, idOrdine = null, idRiga = null, apiKey, pacchetto, rif, desc, fattura, date }) => {
        let url = 'https://api.onesignal.com/notifications';
        let headers = {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${oneSignalKey}`
        }
        let body = {
            app_id: oneSignalAppID,
            headings: {
                en: pacchetto ? "Activate your service package" : "Confirm your transaction",
                it: pacchetto ? "Registra il tuo pacchetto" : "Conferma il tuo utilizzo"
            },
            name: pacchetto 
                ? `Pacchetto - ${client.email} - ID ${client.id} - ${importo} PP` 
                : `Transazione - ${client.email} - ID ${client.id} - ${importo} PP`,
            contents: {
                en: pacchetto
                    ? "Tap to confirm the activation of your service package"
                    : `Tap to confirm the transaction of ${importo} PetPenny`,
                it: pacchetto ?
                    "Clicca per confermare l'attivazione del tuo pacchetto di servizi" :
                    `Clicca per confermare la transazione di ${importo} PetPenny`
            },
            target_channel: "push",
            filters: [{
                field: "tag",
                key: "email",
                relation: "=",
                value: client.email.toLowerCase()
            }],
            data: {
                id,
                idClient: client.id,
                idPet: pet ? pet.id : null,
                importo,
                idClinica,
                nomeClinica,
                idProdotto,
                idOrdine,
                idRiga,
                apiKey,
                pacchetto,
                rif,
                desc,
                fattura,
                date
            }
        }
        try {
            let res = await axios.post(url, body, { headers });
            return res
        } catch (error) {
            console.log(error);
        }
    }

    const getOrderRowById = async (idOrdine) => {
        let url = host + `/apiPortale/rigaOrdine`;
        try {
            let res = await axios.post(url, { id: idOrdine }, {
                headers: {
                    apiKey: ourKey
                }
            });
            return res.data.order_details[0]
        } catch (error) {
            console.log(error);
        }
    }

    return {
        genera,
        getStato,
        sendNotifications,
        login,
        getPetById,
        getPetsOfCustomer,
        getClientById,
        getClientBySearch,
        getPacchetti,
        getOrderRowById
    }
}
